import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_ARTICLE_HOME_LIST,
    getArticleHomeListFail,
    getArticleHomeListSuccess
} from '../action/getArticleHomeListAction'

// api 
import getArticleHomeListApi from '../api/getArticleHomeListApi'

export function* getArticleHomeListSaga(action) {
    try {
        const response = yield call(() => getArticleHomeListApi(action.params))
        if (response.data.status === 1) {
            yield put(getArticleHomeListSuccess(response, action))
        } else {
            yield put(getArticleHomeListFail(response, action))
        }
    }
    catch (e) {
        yield put(getArticleHomeListFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_ARTICLE_HOME_LIST, getArticleHomeListSaga)
}